import { IconButton, TableCell, Tooltip, Stack } from "@mui/material";
import { WhatsApp } from "@mui/icons-material";
import CheckIcon from "@mui/icons-material/Check";

interface FollowUpActionsProps {
  row: any;
  onOpenModal: (row: any) => void;
}

export function FollowUpActions({ row, onOpenModal }: FollowUpActionsProps) {
  const hasNotificationSent =
    // Para MedicationRequest
    row?.medicationRequest?.extension?.find((extension: any) =>
      extension?.url.includes("notificationSent")
    ) ||
    // Para DocumentReference
    row?.fullResource?.extension?.find((extension: any) =>
      extension?.url.includes("notificationSent")
    );

  return (
    <TableCell align="center">
      <Stack
        direction="row"
        justifyContent="center"
        alignItems="center"
        spacing={1}
      >
        <Tooltip title="Enviar mensagem de acompanhamento via WhatsApp">
          <IconButton
            onClick={() => onOpenModal(row)}
            size="small"
            color="primary"
          >
            <WhatsApp />
          </IconButton>
        </Tooltip>
        {hasNotificationSent && (
          <Tooltip title="Notificação enviada">
            <CheckIcon sx={{ fontSize: 16, color: "success700.main" }} />
          </Tooltip>
        )}
      </Stack>
    </TableCell>
  );
}
